// extracted by mini-css-extract-plugin
module.exports = {"form":"Subscription_form__flwr5","input":"Subscription_input__lue6c","btn":"Subscription_btn__wOiew"};